<capra-toast
  class="dataset-publish-success-toast"
  type="success"
  [showCloseBtn]="true"
  [canTapToDismiss]="false"
  (dismissToast)="dismissToast()"
>
  <div>
    <p class="toast-header">Publication initiated</p>
    <p class="toast-text">
      The table will appear in your Data workspace as soon as it’s ready. This can take a few minutes.
    </p>
    <div class="toast-ctas">
      <capra-button
        class="dismiss-cta"
        data-test="dismiss-cta"
        (click)="dismissToast()"
        variant="secondary"
        color="neutral"
        size="small"
        text="Dismiss"
      ></capra-button>
      <capra-button-link
        data-test="ts-data-workspace-link-cta"
        [href]="thoughtspotDataWorkspaceLink"
        variant="secondary"
        color="neutral"
        size="small"
        text="Go to Data workspace"
        icon="icon-new-tab"
        iconLocation="right"
      ></capra-button-link>
    </div>
  </div>
</capra-toast>
